
import React from 'react';
import { Link } from 'react-router-dom';
import { useLogoUrl } from '@/hooks/useLogoUrl';

interface HeaderBrandingProps {
  isMasterAdmin: boolean;
  isMasterLicenseRoute: boolean;
  brandName?: string;
}

const HeaderBranding: React.FC<HeaderBrandingProps> = ({ 
  isMasterAdmin, 
  isMasterLicenseRoute,
  brandName 
}) => {
  const logoUrl = useLogoUrl();
  
  return (
    <Link to="/" className="flex-shrink-0">
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt="Company Logo" 
          className="h-8 w-auto object-contain"
        />
      ) : (
        <div className="flex items-center">
          {/* Default logo image when custom logo isn't available */}
          <img 
            src="/lovable-uploads/36c87bd9-7bdf-4413-bf74-70043278eb04.png"
            alt="ReferMe Logo"
            className="h-8 w-auto mr-2 object-contain"
          />
          <h1 className="text-xl font-bold">
            {isMasterAdmin || isMasterLicenseRoute ? "Master License Portal" : brandName || "ReferMe.site"}
          </h1>
        </div>
      )}
    </Link>
  );
};

export default HeaderBranding;
